document.addEventListener('DOMContentLoaded', function() {

    // Get all the tab buttons
    const tabButtons = document.querySelectorAll('.tab-button');

    // Get all the tab panels
    const tabPanels = document.querySelectorAll('.tab-panel');

    // Get the section wrapper
    const sectionWrapper = document.querySelector('.section2-kickstarter__template');

    // Function to switch tabs
    function switchTab(event) {
      // Remove the 'active' class from all tab buttons and tab panels
      tabButtons.forEach(button => button.classList.remove('active'));
      tabPanels.forEach(panel => panel.style.display = 'none');

      // Add the 'active' class to the clicked tab button
      this.classList.add('active');

      // Get the data-tab attribute value of the clicked tab button
      const tabId = this.getAttribute('data-tab');

      // Show the corresponding tab panel
      const tabPanel = document.getElementById(tabId);
      tabPanel.style.display = 'block';

      // Get the background color of the selected tab button
      const buttonColor = window.getComputedStyle(this).getPropertyValue('background-color');
      // Set the background color of the section wrapper
      sectionWrapper.style.backgroundColor = buttonColor;
    }

    // Add click event listener to each tab button
    tabButtons.forEach(button => button.addEventListener('click', switchTab));

    // Select the first tab by default
    const firstTabButton = tabButtons[1];
    firstTabButton.click(); // Simulate a click event on the first tab button

    
    // Smooth scroll to target section
    function smoothScrollTo(targetElement) {
        if (targetElement) {
            targetElement.scrollIntoView({ behavior: 'smooth'});
        }
    }

    // Get the "Buy Now" button element
    const buyNowButton = document.querySelector('.hero-btn');

    // Add click event listener to the "Buy Now" button
    buyNowButton.addEventListener('click', function() {
      const targetSection = document.querySelector('[js-kickstarter-item]');
      smoothScrollTo(targetSection);
    });

    // Check if the URL contains a query parameter
    const urlParams = new URLSearchParams(window.location.search);
    const tabParam = urlParams.get('tab');

   if (tabParam) {
      let tabIndex;
      var hash = '#shopify-section-kickstarter-template';
      var section = document.querySelector(hash);
       var sectionHeight = section.offsetHeight;
    var windowHeight = window.innerHeight;
    var scrollPosition = section.offsetTop - (windowHeight - sectionHeight) + (-240);
    
      if (tabParam === 'digital') {
         if (section) {
        window.scrollTo({ top: scrollPosition, behavior: 'smooth' });
        }
        tabIndex = 1;
      } else if (tabParam === 'physical') {
          if (section) {
        window.scrollTo({ top: scrollPosition, behavior: 'smooth' });
        }
        tabIndex = 2;
      } else if (tabParam === 'superfan') {
          if (section) {
        window.scrollTo({ top: scrollPosition, behavior: 'smooth' });
        }
        tabIndex = 3;
      }


      if (tabIndex) {
        // Find the corresponding tab button based on the tab index
        const tabButton = tabButtons[tabIndex - 1];

        // If a matching tab button is found, select the tab
        if (tabButton) {
          tabButton.click();
        }
      }
    }

    const btnCloseList = document.querySelectorAll('button.btn-close-addons');
    const rewardList = document.querySelectorAll('section.reward');
    
    
        for (let i = 0; i < btnCloseList.length; i++) {
            const btnClose = btnCloseList[i];
            const reward = rewardList[i];
          
            btnClose.addEventListener('click', () => {
              if (reward.classList.contains('is--active')) {
                reward.classList.remove('is--active');
                document.documentElement.style.overflowY = 'auto';
                document.body.style.overflowY = 'auto';
              }
            });
          }

    var rewardSections = document.querySelectorAll('section.reward');
    var addToCartButtons = document.querySelectorAll('button.btn-add-to-cart');
  
    var timeoutId;
  
    for (var i = 0; i < addToCartButtons.length; i++) {
        addToCartButtons[i].addEventListener('click', function() {
            clearTimeout(timeoutId);
            var button = this;
            timeoutId = setTimeout(function() {
            var productId = button.getAttribute('data-product-id');
            for (var j = 0; j < rewardSections.length; j++) {
                if (rewardSections[j].getAttribute('data-product-id') === productId) {
                    document.documentElement.style.overflowY = 'hidden';
                    document.body.style.overflowY = 'hidden';
                    rewardSections[j].classList.add('is--active');
            
                } else {
                    rewardSections[j].classList.remove('is--active');
                }
            }
            }, 600);
        });
    } 
});